// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3keoP","right":"styles_right__gAt6a"};